import './public-path';
import '@babel/polyfill';
import { polyfillWebComponents } from './webcomponent-polyfill';

polyfillWebComponents().then(async () => {
    await import ('./zui-imports');
});
